<template>
    <BaseLayout :title="pageTitle">
        <div class="text-text bg-background min-h-screen">
            <div class="relative min-h-screen flex flex-col overflow-x-hidden">
                <header class="flex justify-between p-6 text-text font-header">
                    <Link :href="route('welcome')">
                        <img
                            :class="{ 'w-28': !$page.props.sidebar.logo_width }"
                            :style="{ width: $page.props.sidebar.logo_width }"
                            :src="$page.props.logo"
                        />
                    </Link>
                    <div class="hidden md:flex items-center space-x-6">
                        <LocaleSwitcher />
                        <ButtonPopover :alignEnd="false">
                            <template #button>
                                <div class="flex items-center gap-x-2">
                                    <p v-text="$lang.get('About')" />
                                    <PhCaretDown class="size-4" />
                                </div>
                            </template>
                            <template #content="{ close }">
                                <div class="flex flex-col gap-y-1 px-2">
                                    <Link
                                        @click="() => close()"
                                        v-for="page in infoPages"
                                        :key="page.id"
                                        :href="route(page.route)"
                                        class="underline-hover"
                                        v-text="page.name"
                                    />
                                </div>
                            </template>
                        </ButtonPopover>

                        <PrimaryButton
                            v-if="$page.props?.auth?.user"
                            size="sm"
                            @click="logout"
                            v-text="$lang.get('Log out')"
                        />
                        <Link
                            v-if="!$page.props?.auth?.user"
                            :href="route('register')"
                            class="underline-hover focus-style"
                            v-text="$lang.get('Register')"
                        />
                        <Link
                            v-if="!$page.props?.auth?.user"
                            :href="route('login')"
                        >
                            <PrimaryButton
                                size="sm"
                                :roundedPill="false"
                                v-text="$lang.get('Login')"
                            />
                        </Link>
                    </div>
                </header>
                <div
                    :class="[
                        showSideBar ? 'translate-x-0' : 'translate-x-full',
                        'inline md:hidden h-full absolute w-full transition-transform duration-500 ease-in-out z-modal ',
                    ]"
                >
                    <div
                        class="relative w-full h-full bg-sidebar text-sidebar-text"
                    >
                        <button
                            @click="showSideBar = !showSideBar"
                            :class="[
                                showSideBar ? 'left-3' : '-left-14',
                                'absolute top-2 bg-primary text-primary-text rounded-full p-2 transition-all duration-500 ease-in-out ',
                            ]"
                        >
                            <transition name="fade" mode="out-in">
                                <PhX v-if="showSideBar" class="w-8" />
                                <PhList v-else class="w-8" />
                            </transition>
                        </button>

                        <div
                            class="flex flex-col items-center w-full pt-16 text-2xl"
                        >
                            <Link
                                :href="route('about')"
                                class="w-fit hover:opacity-50 px-3 py-2 focus:outline-none transition-opacity duration-150"
                                v-text="$lang.get('About')"
                            />
                            <Link
                                :href="route('register')"
                                class="w-fit hover:opacity-50 px-3 py-2 focus:outline-none transition-opacity duration-150"
                                v-text="$lang.get('Register')"
                            />
                            <Link
                                :href="route('login')"
                                class="w-fit hover:opacity-50 px-3 py-2 focus:outline-none transition-opacity duration-150"
                                v-text="$lang.get('Login')"
                            />
                        </div>
                    </div>
                </div>

                <div class="px-5 md:px-0 flex-grow h-full flex flex-col">
                    <slot />
                </div>
            </div>
        </div>
    </BaseLayout>
</template>

<script>
import BaseLayout from '@/Layouts/BaseLayout.vue'
import { Link, router } from '@inertiajs/vue3'
import LocaleSwitcher from '@/Components/Profile/LocaleSwitcher.vue'
import PrimaryButton from '@/Components/Elements/PrimaryButton.vue'
import ButtonPopover from '@/Components/Utilities/ButtonPopover.vue'
import { PhList, PhX, PhCaretDown } from '@phosphor-icons/vue'

export default {
    components: {
        BaseLayout,
        Link,
        PhList,
        PhX,
        PhCaretDown,
        LocaleSwitcher,
        PrimaryButton,
        ButtonPopover,
    },

    props: {
        pageTitle: {
            type: String,
            default: null,
        },
    },

    data: () => ({
        showSideBar: false,
    }),

    created() {
        this.infoPages = [
            { id: 1, route: 'about', name: this.$lang.get('About') },
            { id: 2, route: 'contact', name: this.$lang.get('Contact') },
            { id: 3, route: 'help', name: this.$lang.get('Help & Support') },
            {
                id: 4,
                route: 'terms.show',
                name: this.$lang.get('Terms of Service'),
            },
            {
                id: 5,
                route: 'policy.show',
                name: this.$lang.get('Privacy Policy'),
            },
            {
                id: 6,
                route: 'attributions',
                name: this.$lang.get('Attributions'),
            },
        ]
    },

    methods: {
        logout() {
            router.post(route('logout'))
        },
    },
}
</script>
